<template>
  <div
    v-if="store.bannerVisible"
    role="alert"
    class="w-full bg-[hsl(var(--destructive))] text-[hsl(var(--destructive-foreground))] shadow-md pt-[env(safe-area-inset-top)]"
  >
    <div class="mx-auto max-w-3xl px-3 py-2 flex flex-col sm:flex-row sm:items-center gap-2">
      <div class="min-w-0 flex-1">
        <p class="text-[13px] font-semibold leading-tight">
          {{ store.state === "overdue"
            ? $t("routeRegistration.banner.overdue")
            : $t("routeRegistration.banner.soon", { minutes: store.minutesLeft ?? 0 }) }}
        </p>
        <p v-if="routeLabel" class="text-[12px] opacity-90 truncate">{{ routeLabel }}</p>
        <p v-if="error" class="text-[12px] font-medium mt-0.5">{{ error }}</p>
      </div>
      <div class="flex gap-2 shrink-0">
        <button
          :disabled="busy"
          @click="run(() => store.extend(60))"
          class="h-8 px-3 rounded-md bg-white text-[hsl(var(--destructive))] text-[12px] font-semibold disabled:opacity-60"
        >{{ $t("routeRegistration.banner.extend") }}</button>
        <button
          :disabled="busy"
          @click="run(() => store.markReturned())"
          class="h-8 px-3 rounded-md border border-white/70 text-[12px] font-semibold disabled:opacity-60"
        >{{ $t("routeRegistration.banner.returned") }}</button>
        <button
          v-if="store.state === 'soon'"
          :disabled="busy"
          @click="store.hideBanner()"
          class="h-8 px-2 text-[12px] font-medium underline underline-offset-2 disabled:opacity-60"
        >{{ $t("routeRegistration.banner.hide") }}</button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useActiveRegistrationStore } from "../store/activeRegistration";

const store = useActiveRegistrationStore();
const { t } = useI18n();
const busy = ref(false);
const error = ref("");

const routeLabel = computed(
  () => store.registration?.route_name || store.registration?.route_description || "",
);

const run = async (action: () => Promise<void>) => {
  if (busy.value) return;
  busy.value = true;
  error.value = "";
  try {
    await action();
  } catch {
    error.value = t("routeRegistration.banner.error");
  } finally {
    busy.value = false;
  }
};
</script>
